import { Card } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

import { useStyles } from './styles';

type SuraCardProps = {
  children: React.ReactNode;
  className?: string;
  style?: object;
};

const SuraCard: React.FC<SuraCardProps> = ({ children, className, style }) => {
  const classes = useStyles();

  return (
    <Card style={style} className={clsx(classes.cardStyle, className)}>
      {children}
    </Card>
  );
};

export default SuraCard;
